/* eslint-disable @typescript-eslint/no-namespace */
import { createAction } from '@ngrx/store';
import { ContainerDTO } from '../models/containerDto';

export namespace ToolTrackerActions {
  // wage sheet selection + cache
  export const selectContainer = createAction(
    '[@ups/tool-tracker] select container',
    (payload: { container: ContainerDTO }) => payload
  );
  export const loadContainersOData = createAction(
    '[@ups/tool-tracker] load containers',
    (payload: { odataQuery?: string }) => payload
  );
  export const loadContainersSuccess = createAction(
    '[@ups/tool-tracker] load containers success',
    (payload: { containers: ContainerDTO[]; count?: number }) => payload
  );
  export const loadContainersError = createAction(
    '[@ups/tool-tracker] load containers error',
    (payload: any) => payload
  );
}
